// #3652 -- the Settings "Rings and days" table and the Classes page's ring/day
// URL filter share ONE definition of "which ring" and "which day".
import { classDayKey } from "./classDisplay";

// A ring name as the operator reads it: whitespace collapsed and trimmed, so
// FVD's "1 Indoor 4    Bell" and "1 Indoor 4 Bell" are one ring. The stored
// name is never rewritten, only grouped and compared through this.
export function normalizeRing(ring) {
  return String(ring ?? "").replace(/\s+/g, " ").trim();
}

// #3662 -- THE one definition of a class the Classes page can show as
// scheduled (#591) and of the two problems the Settings table flags:
// "noRing" (no ring once whitespace-collapsed) and "noDay" (a ring but no venue
// day, read through classDayKey, so a class with only `time` HAS a day).
// The Settings counts, the Classes page's default hide and its
// ?problem=noRing|noDay view all call this, so they cannot disagree.
export const CLASS_PROBLEMS = ["noRing", "noDay"];
export function classProblem(c) {
  if (!normalizeRing(c?.ring)) return "noRing";
  if (!classDayKey(c)) return "noDay";
  return null;
}

// Rows = one per ring that has any class, columns = every venue day any class
// has (ascending), cells = class counts. `day` is classDayKey (the venue day
// key the rest of score uses), never the browser zone and never the UTC date.
// `total` counts only classes WITH a day; no-day and no-ring classes are the
// problem counts, not a row.
export function buildRingDayTable(classes) {
  const rings = new Map();
  const dayKeys = new Set();
  let noRing = 0;
  let noDay = 0;
  for (const c of classes ?? []) {
    const ring = normalizeRing(c.ring);
    const problem = classProblem(c);
    if (problem === "noRing") {
      noRing += 1;
      continue;
    }
    if (!rings.has(ring)) rings.set(ring, { ring, counts: {}, total: 0 });
    if (problem === "noDay") {
      noDay += 1;
      continue;
    }
    const day = classDayKey(c);
    dayKeys.add(day);
    const row = rings.get(ring);
    row.counts[day] = (row.counts[day] ?? 0) + 1;
    row.total += 1;
  }
  const rows = [...rings.values()].sort((a, b) =>
    a.ring.localeCompare(b.ring, undefined, { numeric: true }),
  );
  return { days: [...dayKeys].sort(), rows, noRing, noDay };
}
